import { analyticsClient } from '../common/analyticsClient';
import type { AnalyticsEventRequest } from './utils/types';

class AnalyticsAPIClient {
  public async trackEvent(payload: AnalyticsEventRequest): Promise<void> {
    await analyticsClient.post('/a/event', payload);
  }
}

export const analyticsAPIClient = new AnalyticsAPIClient();
